export default __webpack_public_path__ + "static/media/85_photo.0829b752.jpg";